import request from '@/plugin/axios'

export function queryBussAllSignRules (data) {
  return request({
    url: '/api/admin/queryBussAllSignRules',
    method: 'get',
    params: data
  })

}
export function updateBussSignRule (data) {
  return request({
    url: '/api/admin/updateBussSignRule',
    method: 'post',
    data: data
  })
}
export function queryUserPhoneIntegralRechargeRecordPage (data) {
  return request({
    url: '/api/score/queryUserPhoneIntegralRechargeRecordPage',
    method: 'get',
    params: data
  })
}
export function queryUserScoreList (data) {
  return request({
    url: '/api/admin/queryUserScoreList',
    method: 'get',
    params: data
  })
}

